// extracted by mini-css-extract-plugin
export var closeButton = "_k7-1";
export var closeX = "_k7-3";
export var container = "_k7-0";
export var image = "_k7-2";